import Vue from 'vue'
import objectUtil from './objectUtil'
import lodashUtils from './lodashUtils'
import calculateUtil from './calculateUtil'
// import * as scanUtils from './scanUtils'

const getValue = objectUtil.getValueByPath
const setValue = objectUtil.setValueByPath

export const $bus = new Vue()

/** @name 校验是否存在上游单据 */
export const checkParentOrder = (formData, searchStock) => {
  // 判断是否存在上游单据的依据
  const parentBiz = getValue(formData, 'order.parentBiz')
  if (parentBiz && searchStock && !searchStock.url) {
    throw new Error('存在上游单据，请配置查询库存明细的接口 searchStock.url！')
  }
  return !!parentBiz
}

/** @name 根据keys找到符合条件的数据项的下标 */
export const findItemByKeys = (data, scanFormData, keys = []) => {
  console.log('根据keys找到符合条件的数据项的下标')
  return data.findIndex((item) => {
    let len = 0
    for (const key of keys) {
      if (getValue(item, key) !== getValue(scanFormData, key)) break
      len += 1
    }
    return len === keys.length
  })
}

/**
 * @name 判断keys中的字段是否相等是否相同
 * @param {*} row 行数据
 * @param {*} scanFormData 扫码识别的数据
 * @param {string[]} [keys=[]] 判断的字段 key 值
 * @param {string} [propName=''] 行数据参与判断的字段 key 值，默认为空字符串，默认值时以 keys 的字符串为准
 *
 * @return {boolean} result 判断结果
 *
 */
export const checkGoodAndBatchIsEq = (row, scanFormData, keys = [], propName = '') => {
  return !keys.some((key) => {
    return (
      lodashUtils.isNone(getValue(scanFormData, key)) ||
      getValue(scanFormData, key) !== getValue(row, propName ? propName : key)
    )
  })
}

/**
 * @name 判断id是否在指定的ids中
 * @param {*} row 数据
 * @param {string[]} [ids=[]] 编号ID集
 * @param {string} [path='id'] 匹配的字段路径
 * @returns {boolean} result 判断结果
 *
 */
export const checkIncludeId = (row, ids = [], path = 'id') => {
  return ids.includes(getValue(row, path))
}

/**
 * @name 根据识别的条码（支持分段扫），生成checkArr
 * @param {*} scanFormData 扫码识别的数据
 * @param {string[]} [keys=[]] 需要判断的字段集，如：goodsStore.batchNumber、goodsStore.periodBegin 和 goodsStore.periodEnd
 * @returns {string[]} checkArr 校验数组
 *
 */
export const setCheckArr = (scanFormData, keys = []) => {
  const arr = []
  // 根据识别的条码（支持分段扫）更新 checkArr
  for (const path of keys) {
    if (getValue(scanFormData, path)) arr.push(path)
  }

  return arr
}

/**
 * @name 判断keys中的字段是否为无值
 * @param {*} row 行数据
 * @param {string[]} [keys=[]] 判断的字段 key 值
 *
 * @return {boolean} result 判断结果
 *
 */
export const checkGoodAndBatchIsNull = (row, keys = []) => {
  return keys.some((key) => lodashUtils.isNone(getValue(row, key)))
}

/** @name 校验验收结论是否相同 */
export const checkAcceptStatus = (
  row,
  scanFormData,
  acceptStatusKey = 'attrs.valueEnum.acceptResult' // 灵科则传：acceptStatus
) => {
  return (
    !getValue(scanFormData, `${acceptStatusKey}.code`) ||
    getValue(scanFormData, `${acceptStatusKey}.code`) === getValue(row, `${acceptStatusKey}.code`)
  )
}

/** @name 校验自定义序列号是否相同 */
export const checkEpcIsEq = (row, vue) => {
  const { origin: epc } = vue.scanResult
  // 有些单据 epc 与 goodsKeeping(或goodsStore)平级，有些则是其属性
  return getValue(row, `${vue.dataGoodsKeepingKey}.epc`) === epc || getValue(row, 'epc') === epc
}

/** @name 累加数量 */
const _amountTotal = (arr, key) => {
  return arr.reduce((acc, cur) => calculateUtil.numberAdd(acc, getValue(cur, key, 0)), 0)
}
export const amountTotal = _amountTotal

/** @name 校验是否超出库存数据范围 */
export const checkStockOfavailable = (data, field, vue, key) => {
  // 查找扫码识别后选中商品的所有明细
  const arr = []
  const goodsInfoKey = key || vue.dataGoodsInfoKey

  for (const item of data) {
    if (getValue(item, `${goodsInfoKey}.id`) === getValue(field, `${vue.dataGoodsInfoKey}.id`)) {
      arr.push(item)
    }
  }

  // 明细的总数
  const amountTotal = _amountTotal(arr, vue.dataAvailableKey)
  // 校验结果
  let status = getValue(field, vue.dataAmountKey) <= amountTotal

  // #6769, 当配置了接口地址 stockAutoUrl 且库存数据大于1时，忽略前端的校验库存明细数据的数量校验。由后端接口 stockAutoUrl 去校验
  if (vue?.stockAutoUrl && arr.length > 1) status = true

  return {
    data: arr,
    status,
    amountTotal,
  }
}

/**
 * @name 校验是否开启序列号管理
 * @param {*} data 扫码识别的数据
 * @returns
 */
export const ifSerial = (data, key = 'goodsDetail.keepingSerial') => {
  return getValue(data, key, false)
}
/**
 * @name 遍历单据明细，自动添加_ID，用于验收/配送类的表单录入场景
 * @param {*} formData 表单数据
 * @param {string} itemsKey items 的属性名
 *
 */
export const addCustomIDToItems = (formData, itemsKey = 'items') => {
  // 单据明细
  const items = getValue(formData, itemsKey, [])
  // 单据明细为空时，则不继续执行
  if (!items?.length) return
  // 遍历单据明细，自动添加_ID
  for (const item of items) {
    item._ID = objectUtil.createID()
  }
}

/**
 * @name 遍历商品明细数据，更新goodsKeeping各属性的值
 * @param {*} item 待修改的明细数据
 * @param {*} data 扫码识别的数据
 * @param {string[]} keys 修改的范围，可能值：goodsKeeping、goodsDetail 等
 * @param {string} [propName='goodsKeeping'] 库存数据的库存字段（注意！查询库存返回的数据灵科也是 goodsKeeping）
 */
export const updateGoodsItem = (item, data, keys = ['goodsKeeping'], propName = '') => {
  for (const key of keys) {
    const propNameKey = propName || key
    if (!data[propNameKey]) {
      if (['price'].includes(key)) {
        setValue(item, key, 0)
      }
      continue
    }
    if (typeof data[propNameKey] === 'object') {
      for (let path in data[propNameKey]) {
        // if (
        //   !lodashUtils.isNone(data[propNameKey][path]) &&
        //   key !== 'goodsDetail' &&
        //   path !== 'manufacturer'
        // ) {
        //   item[key][path] = data[propNameKey][path]
        // }

        // #9228,#9231 更新生产企业至明细
        if (!lodashUtils.isNone(data[propNameKey][path])) {
          if (key !== 'goodsDetail' && path !== 'manufacturer') {
            item[key][path] = data[propNameKey][path]
          } else {
            if (
              (key === 'goodsDetail' && path === 'manufacturer') ||
              (key === 'goodsInfo' && path === 'manufacturerName')
            ) {
              console.log(key, path, data)
              item[key][path] = data[key][path]
            }
          }
        }
      }
    } else {
      setValue(item, key, data[propNameKey])
    }
  }
}

/**
 * @name 查找所有相同的行
 * @desc 如果存在ifParent表示明细中存在parent，主行和从行的parent一样
 *
 */
const _seachRows = (data, dataGoodsInfoKey = 'goodsDetail', ifParent = true) => {
  const arr = new Map()

  data.map((item, index) => {
    let id = item?.[dataGoodsInfoKey]?.id
    if (ifParent) id = item?.parent

    const now = arr.get(id)
    if (now) {
      now.push({ index, item })
    } else {
      arr.set(id, [{ index, item }])
    }
  })

  return arr
}
export const seachRows = _seachRows

/**
 * @name 根据指定的key,在指定的数组中，查找所有相同的行
 * @desc 如果存在ifParent表示明细中存在parent，主行和从行的parent一样
 *
 */
const _seachRowsForArr = (data, key = 'goodsDetail.id', ifParent = true) => {
  const arr = new Map()

  data.map((item, index) => {
    let id = getValue(item, key)
    if (ifParent) id = item?.parent

    const now = arr.get(id)
    if (now) {
      now.push({ index, item })
    } else {
      arr.set(id, [{ index, item }])
    }
  })

  return arr
}
export const seachRowsForArr = _seachRowsForArr

/** @name 找出主行 */
export const seachMaster = (arr, key) => {
  return arr.find((item) => getValue(item, key ? `${key}.master` : 'master'))
}

/** @name 找出parent相同的所有明细 */
export const parentIsSame = (arr, row) => {
  const items = arr.filter((im) => im.parent === row.parent)
  return { success: items?.length > 0, arr: items }
}

/** @name 拆行逻辑 */
export const getSplitRow = (row, clearPlan = false) => {
  let splitRow = objectUtil.clone(row)
  // 主行 master 强制置为 false, 计划数量置为null
  // splitRow.plan = null // 无源新建手术配货单需要 plan
  splitRow.master = false
  splitRow.id = null
  if (clearPlan) splitRow.plan = null

  splitRow._ID = objectUtil.createID()
  return splitRow
}

/** @name 价格反算 */
export const backCountPrice = (formData, goodsDetail, vue) => {
  console.log('价格反算')
  let isOrderDiscountsTotalFn = false //是否需要计算折扣金额总计

  let tempPrice = [
    'PRODUCT_SHOPPING_10',
    'PRODUCT_SHOPPING_20',
    'PRODUCT_SHOPPING_30',
    'PRODUCT_SHOPPING_40',
  ]
  let code = objectUtil.getValueByPath(formData, 'order.priceRange.code')

  if (vue.useBackCountAddItems && vue.store) {
    //从往来单位取价
    if (tempPrice.indexOf(code) == -1) {
      //取上一次的价格且报价为0或不存在
      if (code == 'PRICE_LAST_SYSTEM' && !goodsDetail.pricing) {
        //价格反算
        vue.store.dispatch(vue.useBackCountAddItems, 'price', goodsDetail)
      } else {
        //刷新价格反算
        vue.store.dispatch(vue.useBackCountAddItems, 'refreshPrice', goodsDetail, formData)
        isOrderDiscountsTotalFn = true
      }
    } else {
      //价格反算
      vue.store.dispatch(vue.useBackCountAddItems, 'pricing', goodsDetail)
    }
  } else {
    console.error('调用计算失败-----useBackCountAddItems不存在或者vue.store不存在')
  }

  return isOrderDiscountsTotalFn
}

/** @name 从库存选择器表格中获取数据更新scanFormData */
const _updateScanFormDataByStockRow = (selectedRow, vue) => {
  console.log('从库存选择器表格中获取数据更新scanFormData')
  // 没有匹配到任务
  if (!selectedRow) throw new Error('没有匹配到的任务')
  const locationItem = vue.searchFormItem('location')
  // 货位不可编辑 locationIsDisabled=true 或者 scanFormData.location 无值时
  const locationIsDisabled = locationItem?.props?.disabled
  // 修复#32390，获取是否为必填 locationIsRequired=true
  const locationIsRequired = locationItem?.props?.required
  const locationArr = [
    'passiveCheckoutInputLocation',
    'checkoutInputLocation',
    'checkoutAndLocation',
    'importAndLocation',
    'importForStock',
    'matchAndImportForStockOfReunion',
    'matchAndImportForStockOfLink',
    'matchAndImportForStockNoParentOfLink',
    'matchAndImportForStockNoParent',
    'importInventoryByStock',
  ]

  // 修复#31175 时，表达式为: locationArr.includes(vue.model) && (!locationItem || locationIsDisabled || !this.scanFormData.location)
  // 修复#32390 时，改为如下表达式
  if (
    locationArr.includes(vue.model) &&
    !lodashUtils.isEmpty(locationItem) &&
    lodashUtils.isNone(vue.scanFormData.location) &&
    (locationIsDisabled || !locationIsRequired)
  ) {
    objectUtil.setValueByPathForVue(vue.scanFormData, 'location', selectedRow.location, vue)
  }
  // 更新 scanFormData.goodsKeeping
  objectUtil.setValueByPath(
    vue.scanFormData,
    vue.dataGoodsKeepingKey,
    selectedRow[vue.dataGoodsKeepingKey] || selectedRow.goodsKeeping //灵科从库存选择时返回的key时goodsKeeping
  )
  //只扫自定义序列号的时候，需要从查询出来的数据中将商品赋值给scanFormData,从库存查时不过灵科还是优联都返回的是goodsDetail
  if (!objectUtil.getValueByPath(vue.scanFormData, `${vue.dataGoodsInfoKey}.id`)) {
    const goods =
      objectUtil.getValueByPath(selectedRow, `${vue.dataGoodsInfoKey}`) ||
      objectUtil.getValueByPath(selectedRow, 'goodsDetail')
    if (goods) {
      // #33478，基本单位没带出来，判断 goods.unit 是否有值，无值则用 selectedRow.unit 赋值（如果先调用查询商品档案的接口，goods.unit 是有值的）
      if (lodashUtils.isNone(goods.unit)) {
        goods.unit = objectUtil.getValueByPath(selectedRow, 'unit')
      }
      objectUtil.setValueByPath(vue.scanFormData, vue.dataGoodsInfoKey, goods)
    }
  }
  //当前模式是选库存批号时需要做一次转换
  if (locationArr.includes(vue.model)) {
    const isLink = vue.isLinkOfSystem
    if (isLink) {
      vue.scanFormData.goodsStore.storageItemId = selectedRow.id || null
      vue.scanFormData.goodsStore.storageDate = selectedRow.date || null
      vue.scanFormData.goodsStore.available = selectedRow.available || null
      vue.scanFormData.goodsStore.epc = selectedRow.epc || null
      vue.scanFormData.goodsStore.deal = selectedRow.deal || null
      // 兼容【我要领用出库单】
      if (vue.model === 'matchAndImportForStockNoParentOfLink') {
        vue.scanFormData.storageItemId = selectedRow.id || null
      }
    }
    vue.scanFormData.available = selectedRow.available || null
    vue.scanFormData.logistics = selectedRow.logistics || null
    vue.scanFormData.location = selectedRow.location || null
    vue.scanFormData[!isLink ? 'warehouse' : 'outWarehouse'] = selectedRow.warehouse || null
    if (!isLink) {
      vue.scanFormData.storageItem = {
        id: selectedRow.id || null,
        code: selectedRow.code || null,
      }
      vue.scanFormData.epc = selectedRow.epc || null
      //目前store 只有available 有值。
      vue.scanFormData.storageAvailable = selectedRow.available || null
      vue.scanFormData.stocking = selectedRow.stocking || null
      vue.scanFormData.deal = selectedRow.dealOne || vue.scanFormData.dealOne || null
    }
    //客户（迭代20增加）
    vue.scanFormData.thirdparty = selectedRow.thirdparty || null
    //无税成本价
    vue.scanFormData.netCost = selectedRow.netCost || null
    vue.scanFormData.netCostDisplay = selectedRow.netCostDisplay || null
    //含税成本价
    vue.scanFormData.cost = selectedRow.cost || null
    vue.scanFormData.costDisplay = selectedRow.costDisplay || null
  }
}
export const updateScanFormDataByStockRow = _updateScanFormDataByStockRow

/**
 * @name 从库存选择器表格中获取到选中的数据（且近效先出、先进先出时，正确更新数量）
 * @param {Vue} vue 上下文
 * @param {any[]} [data=[]] 库存数据
 * @param {string} [path='amountOut'] 取值数量的路径
 *
 */
export const selectedRowFromStock = (vue, data = [], path = 'amountOut') => {
  // 找到数量有值的数据
  const arr = data.filter((item) => item[path] || item[vue.dataAmountKey])
  // 查找所有相同的库存的行，这里就通过 id 查找相同库存，后续会在 updateScanFormDataByStockRow 方法中，赋值给 storageItemId（灵科）或 storageItem.id（优联）
  const task = _seachRowsForArr(arr, 'id', false)
  //
  const newArr = []

  for (let [, val] of task) {
    let amoutAll = vue.amountTotal(val, `item.${path}`)
    let availableAll = vue.amountTotal(val, 'item.available')
    let stockingAll = vue.amountTotal(val, 'item.stocking')
    let storageAvailableAll = vue.amountTotal(val, 'item.storageAvailable')
    const item = val[0]
    const selected = item?.item
    if (selected) {
      newArr.push({
        ...selected,
        [`${vue.dataAmountKey}`]: amoutAll,
        available: availableAll,
        stocking: stockingAll,
        storageAvailable: storageAvailableAll,
      })
    }
  }

  return newArr
}

/**
 * @name 校验库存选择器选中的数据合法性
 * @description 例如：可用量必须<=数量，或者数量为空或为0的项
 * @param {any[]} [stockData=[]] 库存数据
 * @param {Vue} vue 指向组件 scanBasicPlus 的上下文
 * @returns {any[]} 新库存数据
 */
export const checkStockData = (stockData, vue) => {
  const arr = []

  for (const stock of stockData) {
    // 可用量
    const available = stock.available
    // 库存当前数量
    const amount = (vue.dataAmountKey in stock ? stock[vue.dataAmountKey] : stock.amountOut) || 0

    console.log('------------------------')
    console.log('amount: ', amount)
    console.log('available: ', available)
    console.log('------------------------')

    // 判断库存是否充足
    if (!vue.stockAutoUrl && amount > available) throw new Error('库存不足')
    // 判断库存当前数量是否为空或者0，如果是则过滤掉
    if (amount > 0) arr.push(stock)
  }

  return arr
}

/**
 * @name 清空指定的键值
 * @param {*} row 待清空的数据
 * @param {string[]} keys 待清空的键值
 */
export const clearForField = (row, keys = []) => {
  for (const key of keys) {
    setValue(row, key, null)
  }
}

/**
 * @name 判断数量是否与计划数量相等
 */
export const checkPlanAndAmount = (data, vue) => {
  const amoutAll = vue.amountTotal(data, 'amountOut')
  const planAll = vue.scanFormData[vue.dataAmountKey]
  const type = vue.$parent?.currentSelected

  if (type !== 'epc' && amoutAll > 0 && amoutAll !== planAll) {
    throw new Error('数量与计划数量不一致')
  }
  // 库存选择器没有任何选择时
  if (!amoutAll) return false

  return true
}

/**
 * @name 校验是否超出上游单据数量范围
 * @param {vue} vue 上下文
 * @param {vue} self self 指向组件 scanStandardPlus 的上下文
 * @param {boolean} [ifParent=true] 是否存在 parent
 */
export const checkParentAmount = (vue, self, ifParent = true) => {
  // 查找上表的任务
  const task = vue.seachRows(ifParent, self)

  for (let [, val] of task) {
    console.log('val: ', val)
    let amoutAll = vue.amountTotal(val, `item.${vue.dataAmountKey}`)
    let planAll = vue.amountTotal(val, `item.${vue.dataPendingKey}`)
    let nowAmount = calculateUtil.numberAdd(amoutAll, vue.scanFormData[vue.dataAmountKey])
    console.log('checkParentAmount planAll: ', planAll)
    console.log('checkParentAmount nowAmount: ', nowAmount)
    // 所有主从行的数量之和（包括此次扫码的数量） 小于计划数量时，应该将所扫信息填入到该主从行中的某一行或拆行
    if (nowAmount > planAll) {
      throw new Error('操作失败，超出上游单据数量范围')
    }
  }
}

/**
 * @name 检查传入的数据data的指定字段是否相等
 * @param {any[]} data 数据
 * @param {string[]} keys 指定字段集
 *
 * @return {boolean} result 检查结果
 */
export const checkItemIsEq = (data, keys = []) => {
  const m = new Map()
  keys.forEach((key) => {
    m.set(key, [])
  })

  data.forEach((item) => {
    for (const key of m.keys()) {
      const val = getValue(item, key)
      // 如果值为空，则 push('EMPTY_VALUE')
      m.get(key).push(lodashUtils.isNil(val) ? 'EMPTY_VALUE' : val)
    }
  })

  for (const val of m.values()) {
    const arr = [...new Set([...val])] // 去重
    // arr 长度超过1，说明有不同的值，即传入的数据data的指定字段不相等
    if (arr.length > 1) {
      return false
    }
  }

  return true
}

/**
 * @name 定数包数量
 * @description
 * 需求#6564，如果是【存货形态】是的【定数包】，则取库存的可用量 availing --【灵科-web-海南】web端支持定数包扫码流程优化
 */
export const setAmountNumberPackage = (stockItem, dataItem, vue) => {
  console.log('--------------- 定数包数量 ---------------')
  console.log('availing: ', stockItem.availing)
  console.log('stockItem: ', stockItem)
  console.log('dataItem: ', dataItem)
  console.log('scanFormData: ', vue.scanFormData)
  console.log('--------------- 定数包数量 End ---------------')
  if (getValue(vue.scanFormData, 'isNumberPackage')) {
    const availing = getValue(stockItem, 'availing', null)
    if (availing == null) {
      stockItem.amountOut = getValue(stockItem, vue.dataAmountKey)
      stockItem.amountOutDisplay = getValue(stockItem, vue.dataAmountKey)
    } else {
      stockItem.amountOut = getValue(stockItem, 'availing')
      stockItem.amountOutDisplay = getValue(stockItem, 'availing')
    }
  } else {
    stockItem.amountOut = getValue(dataItem, vue.dataAmountKey, 1)
    stockItem.amountOutDisplay = getValue(dataItem, vue.dataAmountKey, 1)
  }

  return stockItem
}

/**
 * @name 查询库存后自动匹配库存明细
 * @description 参考【6497】中的维度进行自动匹配。先按照近效先出，如果还有多条信息，再按照【先进先出】匹配（也就是匹配入库时间最早的）
 *
 */
export const autoMatchStock = async ({ vue }) => {
  const url = vue?.stockAutoUrl
  const codeType = vue.scanResult.codeType || '普通码'
  console.log('查询库存后自动匹配库存明细', url)
  console.log('AutoMatchStock 解析识别的条码:', codeType)
  if (url && codeType !== '普通码') {
    // 调用接口查询
    const params = {
      ...vue.queryStockOfParams,
      ...vue.stockAutoParams,
      criteriaCode: vue.stockAutoParams?.criteriaCode,
      parameters: {
        outAmount: vue.scanFormData?.amount,
        goodsId: vue.goodsInfo?.id,
        ...vue.queryStockOfParams?.parameters,
        ...vue.stockAutoParams?.parameters,
      },
    }
    const request = vue?.$axios
    const res = await request?.post(url, params)

    if (res?.data?.code === 200) {
      return [true, res.data?.data]
    }
    if (res?.data?.code === 400) {
      throw new Error(vue.availableErrorMessage)
    }
  }

  return [false]
}
